import { ChangeUsernamePasswordFormSC } from './ChangeUsernamePasswordForm.styled'

interface ISettingsMenuProps {
  title?: string
  children: React.ReactNode
}

export const ChangeUsernamePasswordForm = ({
  // title,
  children,
}: ISettingsMenuProps) => {
  return <ChangeUsernamePasswordFormSC>{children}</ChangeUsernamePasswordFormSC>
}
